import {
	Group,
	Button,
	TextInput,
	Textarea,
	CopyButton,
	Tooltip,
	Modal,
} from "@mantine/core";
import { ActionIcon } from "@mantine/core";
import { IconCopy, IconCheck } from "@tabler/icons";

const ShareModal = ({ opened, setOpened, id }) => {
	return (
		<Modal
			centered
			size="lg"
			opened={opened}
			onClose={() => {
				setOpened(false);
			}}
			title="Share"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: {
					color: "#ffffff",
					fontWeight: "700",
					width: "100%",
					textAlign: "center",
				},
			}}
		>
			<Group my={10} style={{ width: "100%" }}>
				<TextInput
					readOnly
					style={{ width: "100%" }}
					styles={{
						input: {
							backgroundColor: "#040F1F",
							border: "1px solid #09254E",
						},
						label: {
							color: "#ffffff",
						},
					}}
					label="Copy this link to the experience"
					value={`https://app.ivisit.io/tour/${id}`}
					rightSection={
						<CopyButton
							value={`https://app.ivisit.io/tour/${id}`}
							timeout={2000}
						>
							{({ copied, copy }) => (
								<Tooltip
									label={copied ? "Copied" : "Copy"}
									withArrow
									position="right"
								>
									<ActionIcon
										color={copied ? "teal" : "gray"}
										onClick={copy}
									>
										{copied ? (
											<IconCheck size={16} />
										) : (
											<IconCopy size={16} />
										)}
									</ActionIcon>
								</Tooltip>
							)}
						</CopyButton>
					}
				/>
			</Group>
			<Group my={10} style={{ width: "100%" }}>
				<Textarea
					readOnly
					style={{ width: "100%" }}
					styles={{
						input: {
							backgroundColor: "#040F1F",
							border: "1px solid #09254E",
						},
						label: {
							color: "#ffffff",
						},
					}}
					label="Use Iframe to embed this experience inside your website"
					value={`<iframe name="IVisit Virtual Tour" src="https://app.ivisit.io/tour/${id}" width="800" height="450" fullscreen"></iframe>`}
					rightSection={
						<CopyButton
							value={`<iframe name="IVisit Virtual Tour" src="https://app.ivisit.io/tour/${id}" width="800" height="450" fullscreen"></iframe>`}
							timeout={2000}
						>
							{({ copied, copy }) => (
								<Tooltip
									label={copied ? "Copied" : "Copy"}
									withArrow
									position="right"
								>
									<ActionIcon
										color={copied ? "teal" : "gray"}
										onClick={copy}
									>
										{copied ? (
											<IconCheck size={16} />
										) : (
											<IconCopy size={16} />
										)}
									</ActionIcon>
								</Tooltip>
							)}
						</CopyButton>
					}
				/>
			</Group>
			<Group
				style={{
					width: "100%",
					justifyContent: "end",
				}}
			>
				<Button
					variant="outline"
					my={0}
					px={25}
					size="xs"
					radius={"md"}
					sx={(theme) => ({
						color: theme.colors.white[0],
						borderColor: theme.colors.ivisit_light[0],
					})}
					onClick={() => {
						setOpened(false);
					}}
				>
					Close
				</Button>
			</Group>
		</Modal>
	);
};

export default ShareModal;
